:host {
    display: flex;
    flex-direction: column;

    // --ux-table-col-template: 150px 150px 170px 140px; 
    // grid-template-columns: 150px 150px 150px 150px;
}